import React, { useState, useEffect, useRef } from "react";

/** Components */
import { Button, ButtonGroup, Collapse, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, TablePagination, Checkbox, Tooltip, Paper } from "@mui/material";
import { FilterBy } from "./../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getKT0401, getOrganizationData } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import axios from "axios";
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { usePagination } from "./../../commons/customHook";
import { useDispatch } from "react-redux";

const initialFilter = {
  start_date: "",
  end_date: "",
  organization: null,
};
const KT0401 = () => {
  // hook
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const ref = useRef({
    getDataSource: null,
  });
  const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination();
  // state
  const [searchOpen, setSearchOpen] = useState(true);
  const [data, setData] = useState();
  const [filter, setFilter] = useState({ ...initialFilter });
  const filterFunc = (item) => true;

  // method
  const getData = () => {
    setData();
    const source = axios.CancelToken.source();
    ref.current.getDataSource?.cancel();
    ref.current.getDataSource = source;
    getKT0401({
      cancelToken: source.token,
      params: {
        start_date: filter.start_date || undefined,
        end_date: filter.end_date || undefined,
        organization_id: filter.organization?.id || undefined,
      },
    }).then((res) => {
      if (res.code === 200) {
        setData(res.data);
      }
    });
  };
  // effect
  useEffect(() => {
    dispatch(setHeaderTitle("BÁO CÁO KT.04.01"));
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => ref.current.getDataSource?.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div align="center">
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {/* filter */}
      <Collapse in={searchOpen} style={{ margin: "10px 0" }}>
        <CustomDatePicker label={t("Ngày bắt đầu")} value={filter.start_date} onChange={(value) => setFilter((prev) => ({ ...prev, start_date: value }))} sx={{ margin: "5px" }} />
        <CustomDatePicker label={t("Ngày kết thúc")} value={filter.end_date} onChange={(value) => setFilter((prev) => ({ ...prev, end_date: value }))} sx={{ margin: "5px" }} />
        <FilterBy
          label={t("Tổ chức")}
          style={{ display: "inline-flex", width: 240, margin: 5 }}
          getDataFunc={() => getOrganizationData()}
          value={filter.organization}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, organization: newValue }))}
        />
        <Button onClick={getData} style={{ margin: "5px" }} variant="outlined">
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      <React.Fragment>
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Ngày
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Giờ
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Số xe
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} colSpan={3}>
                  Chứng chỉ xuất hàng
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }}>Chứng chỉ bồn xuất</TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} colSpan={6}>
                  Kiểm tra chất lượng mẫu xả đáy phương tiện
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Chênh lệch tỉ trọng giữa (7) và (13)
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Độ dẫn điện
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Bồn nhập
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={3}>
                  Người kiểm tra
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Số chứng chỉ
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Lô số
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Tỉ trọng ở 15°C
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Tỉ trọng ở 15°C
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Lần xả thứ
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Ngoại quan
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} rowSpan={2}>
                  Thử nước
                </TableCell>
                <TableCell style={{ border: "1px solid lightgray" }} colSpan={3}>
                  Kiểm tra tỉ trọng
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ border: "1px solid lightgray" }}>Tỉ trọng thực tế</TableCell>
                <TableCell style={{ border: "1px solid lightgray" }}>Nhiệt độ</TableCell>
                <TableCell style={{ border: "1px solid lightgray" }}>Tỉ trọng ở 15°C</TableCell>
              </TableRow>
              <TableRow>
                {[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_, index) => (
                  <TableCell key={index} style={{ border: "1px solid lightgray" }}>
                    ({index + 1})
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.filter(filterFunc)?.length ? (
                data
                  .filter(filterFunc)
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.date && moment(item.date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.date && moment(item.date).format("HH:mm")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.vehicle}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.rc_certificate}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.rc_batch}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.rc_d15 && parseFloat(item.rc_d15).toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.trc_d15 && parseFloat(item.trc_d15).toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.sc_drain}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>
                        <Checkbox checked={Boolean(item.sc_appearance)} disabled />
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>
                        <Checkbox checked={Boolean(item.sc_swd)} disabled />
                      </TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.sc_density ? parseFloat(item.sc_density).toFixed(4) : ""}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.sc_temperature ? parseFloat(item.sc_temperature)?.toFixed(2) : ""}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.sc_d15}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{(item.sc_d15 - item.trc_d15)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.conductivity}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.imp_tanks && JSON.parse(item.imp_tanks) && JSON.parse(item.imp_tanks).map((sub_item) => sub_item.code)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{item.checker}</TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={20}>{t("Không có dữ liệu")}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data?.filter(filterFunc).length || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={setRowsPerPage}
        />
      </React.Fragment>
    </div>
  );
};
export default KT0401;
